module.exports = __webpack_public_path__ + "static/img/logo_zgnykxy.048b695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_zgnykxy.png
// module id = v+ht
// module chunks = 15